<!--================================
=            ITEMGROUPS            =
=================================-->

<template>
  <!-- WIDGETS CARDS -->
  <v-container >
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Item Groups</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <v-container>
              <v-row justify="space-around">
                <v-switch v-model="mandatory" label="Mandatory"></v-switch>
                <v-switch v-model="multiple" label="Multiple"></v-switch>
                <v-col cols="12">
                  <v-select v-model="type" :items="types" label="Item type"></v-select>
                </v-col>
              </v-row>

              <v-item-group :mandatory="mandatory" :multiple="multiple">
                <v-container class="pa-0">
                  <v-row>
                    <v-col v-for="n in 3" :key="n" cols="12" md="4">
                      <v-item v-slot:default="{ active, toggle }">
                        <v-card v-if="type === 'cards'" :color="active ? 'primary' : ''" class="d-flex align-center"
                          dark height="200" @click="toggle">
                          <v-scroll-y-transition>
                            <div v-if="active" class="display-3 flex-grow-1 text-center">Active</div>
                          </v-scroll-y-transition>
                        </v-card>
                        <v-img v-else src="https://picsum.photos/id/237/200/300" height="150" class="text-right pa-2"
                          @click="toggle">
                          <v-btn icon dark>
                            <v-icon>{{ active ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                          </v-btn>
                        </v-img>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple</div>
          <div slot="card-body">
            <v-item-group multiple>
              <v-container>
                <v-row>
                  <v-col v-for="n in 3" :key="n" cols="12" md="4">
                    <v-item v-slot:default="{ active, toggle }">
                      <v-card :color="active ? 'primary' : ''" class="d-flex align-center" dark height="200"
                        @click="toggle">
                        <v-scroll-y-transition>
                          <div v-if="active" class="display-3 flex-grow-1 text-center">Active</div>
                        </v-scroll-y-transition>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Mandatory</div>
          <div slot="card-body">
            <v-item-group mandatory>
              <v-container>
                <v-row>
                  <v-col v-for="n in 3" :key="n" cols="12" md="4">
                    <v-item v-slot:default="{ active, toggle }">
                      <v-card :color="active ? 'primary' : ''" class="d-flex align-center" dark height="200"
                        @click="toggle">
                        <v-scroll-y-transition>
                          <div v-if="active" class="display-3 flex-grow-1 text-center">Active</div>
                        </v-scroll-y-transition>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">With active class</div>
          <div slot="card-body">
            <v-item-group active-class="primary">
              <v-container>
                <v-row>
                  <v-col v-for="n in 3" :key="n" cols="12" md="4">
                    <v-item v-slot:default="{ active, toggle }">
                      <v-card class="d-flex align-center" dark height="200" @click="toggle">
                        <v-scroll-y-transition>
                          <div v-if="active" class="display-3 flex-grow-1 text-center">Active</div>
                        </v-scroll-y-transition>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom groups</div>
          <div slot="card-body">
            <v-card max-width="400" class="mx-auto">
              <v-container class="pa-1">
                <v-item-group v-model="selected" multiple>
                  <v-row>
                    <v-col v-for="(item, i) in items" :key="i" cols="12" md="6">
                      <v-item v-slot:default="{ active, toggle }">
                        <v-img :src="`https://cdn.vuetifyjs.com/images/${item.src}`" height="150"
                          class="text-right pa-2" @click="toggle">
                          <v-btn icon dark>
                            <v-icon>{{ active ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                          </v-btn>
                        </v-img>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </v-container>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Chips</div>
          <div slot="card-body">
            <v-card>
              <v-toolbar flat color="blue-grey" dark>
                <v-toolbar-title>Submit a post</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-text-field filled label="Title" value="My new post"></v-text-field>

                <v-textarea filled label="Text"
                  value="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse">
                </v-textarea>

                <v-divider class="my-2"></v-divider>

                <v-item-group multiple>
                  <v-subheader>Tags</v-subheader>
                  <v-item v-for="n in 8" :key="n" v-slot:default="{ active, toggle }">
                    <v-chip active-class="purple--text" :input-value="active" @click="toggle">Tag {{ n }}</v-chip>
                  </v-item>
                </v-item-group>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" depressed>Post</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>

  </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    },
    data: () => ({
      types: ["cards", "images"],
      type: "cards",
      mandatory: false,
      multiple: true,
      items: [{
          src: "backgrounds/bg.jpg"
        },
        {
          src: "backgrounds/md.jpg"
        },
        {
          src: "backgrounds/bg-2.jpg"
        },
        {
          src: "backgrounds/md2.jpg"
        }
      ],
      selected: []
    })
  };
</script>

<!--====  End of ITEMGROUPS  ====-->
